{
  "nav": {
    "dashboard": "Panel",
    "teacherDashboard": "Mis sesiones",
    "projects": "Proyectos",
    "fairQuote": "Fair Quote",
    "exitFairQuote": "Salir de Fair Quote",
    "contacts": "Contactos",
    "entities": "Entidades",
    "products": "Productos",
    "colors": "Colores",
    "courses": "Cursos",
    "teachers": "Profesores",
    "students": "Estudiantes",
    "certifications": "Certificaciones",
    "staff": "Personal",
    "company": "Mi empresa",
    "overview": "Resumen",
    "sections": {
      "projects": "Proyectos",
      "shop": "Tienda & Catálogo",
      "entity": "Espacio de entidad",
      "learning": "Formación",
      "admin": "Administración"
    },
    "enrollments": "Inscripciones",
    "calendar": "Calendario",
    "userManagement": "Gestión de usuarios",
    "applicatorProfiles": "Perfiles de aplicadores",
    "certificationDefinitions": "Definiciones de certificaciones",
    "switchEntity": "Cambiar entidad"
  }
}
